/**
 * 환경설정 단일 출처.
 *
 * API 주소를 코드에 하드코딩하지 않는다. 값은 .env 에서 주입한다.
 * (P2 Vite 전환 시 REACT_APP_* → import.meta.env.VITE_* 로 바뀌는 곳은 이 파일뿐이다.)
 */

/**
 * API 모드
 *   mock : 브라우저 localStorage 에 저장되는 데모 데이터로 동작한다. 백엔드 없이
 *          로그인 · 마이페이지 · 견적 · 문의 전 흐름을 시연할 수 있다.
 *   http : REACT_APP_API_BASE_URL 의 Spring 백엔드를 호출한다.
 *
 * 기본값은 mock — 백엔드가 준비되지 않은 환경에서도 사이트가 완전하게 동작해야 한다.
 */
export const API_MODE = (process.env.REACT_APP_API_MODE || 'mock').toLowerCase();

export const IS_MOCK = API_MODE !== 'http';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8855/api';

/**
 * 목 모드 로그인 계정 (하나만). 목 DB 시드와 로그인 검증이 이 값을 쓴다.
 * http 모드에서는 백엔드 DB 의 계정을 쓰므로 이 값은 무시된다.
 */
export const TEST_ACCOUNT = {
  email: process.env.REACT_APP_TEST_ACCOUNT_EMAIL || 'admin@trinitylaserprofile.com',
  password: process.env.REACT_APP_TEST_ACCOUNT_PASSWORD || 'Trinity#2026'
};

/** 첨부파일 최대 크기 — 100MB. GCS 서명 URL 직접 업로드로 처리한다. */
export const MAX_UPLOAD_BYTES = Number(
  process.env.REACT_APP_MAX_UPLOAD_BYTES || 104857600
);

/** 화면 표기 통화. 호주 법인이므로 AUD. */
export const CURRENCY = process.env.REACT_APP_CURRENCY || 'AUD';

/** 통화 로케일 — 금액 표기 형식 */
export const CURRENCY_LOCALE = process.env.REACT_APP_CURRENCY_LOCALE || 'en-AU';
